import React, { useState } from 'react';
import MapPng from 'assets/img/map-animation/map.png';

import './map-animation.scss';

const MapAnimation = () => {
    const [mapLoaded, setMapLoaded] = useState(false);

    return (
        <div className="map-animation">
            <img className="worldmap"
                src={ MapPng }
                alt=""
                onLoad={ () => setMapLoaded(true) } />
            {
                !mapLoaded ? null : (
                    <>
                        <div className="dot dot-taiwan">
                            <span />
                            <span />
                            <span />
                        </div>
                        <div className="dot dot-jakarta">
                            <span />
                            <span />
                            <span />
                        </div>
                        <div className="location" />
                        <div className="path">
                            <svg width="82px"
                                height="175px"
                                viewBox="0 0 82 175"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlnsXlink="http://www.w3.org/1999/xlink">
                                <g id="Page-1" stroke="none" fill="none" fillRule="evenodd">
                                    <path strokeLinecap="round" d="M80.0505624,2 C53.0059498,25.1530591 33.1232753,50.6986293 20.4025391,78.6367104 C7.68180291,106.574791 1.55596355,138.150755 2.02502104,173.364602" id="Path" stroke="#01FFDA" strokeWidth="3"></path>
                                </g>
                            </svg>
                        </div>
                    </>
                )
            }
        </div>
    );
};
export default MapAnimation;
